import { styled } from '@mui/system';
import { BasisRoot } from 'screens/styles';

const QuestionsRoot = styled(BasisRoot, {target: 'QuestionsRoot'} )(({ theme}) => ({
    display: 'flex',
    flexDirection: 'column'
}))


export { QuestionsRoot }